<template>
  <!-- Overlay centralizado com Vuetify -->
  <v-overlay
    :model-value="true"
    persistent
    class="z-index-max"
    scrim="transparent"
  >
    <!-- Loader circular customizado -->
    <div
      class="mx-auto"
      style="
        width: 80px;
        height: 80px;
        border: 4px solid var(--v-theme-grey-lighten-2);
        border-top-color: var(--v-theme-success);
        border-radius: 50%;
        animation: spin 1s linear infinite;
      "
    ></div>
  </v-overlay>
</template>

<style scoped>
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Define z-index alto dentro do escopo Vuetify */
.z-index-max {
  z-index: 9999 !important;
}
</style>
